import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { createUseStyles } from 'react-jss'
import { UserIcon } from '../UserIcon/UserIcon'
import { ProfileCardBase } from '../ProfileCardBase/ProfileCardBase'
import { Badges } from '../Badges/Badges'
import { Role } from '../Role/Role'
import { Anchor } from '../../../Global/Anchor'
import { Social } from '../Social/Social'

const useStyles = createUseStyles(
  {
    'profile-card': {
      width: '100%',
      display: 'grid'
    },
    'profile-card-full-name': {
      margin: '12px'
    },
    'profile-card-user-name': {
      float: 'left',
      marginLeft: '15px',
      marginTop: '6px',
      fontSize: '16px'
    },
    'profile-card-role': {
      padding: '12px',
      float: 'right'
    },
    'profile-card-badges-block': {
      alignItems: 'center',
      margin: '0px 2px 0px 2px',
      fontSize: '12px'
    },
    email: { padding: '8px', margin: 0 },
    social: {
      justifyContent: 'space-evenly',
      padding: '0',
      display: 'flex',
      margin: '0 0 6px 0'
    },
    'online-badge': {
      border: 'green 1px solid',
      borderRadius: '50%',
      float: 'left'
    },
    'offline-badge': {
      border: 'red 1px solid',
      borderRadius: '50%',
      float: 'left'
    },
    'root-icon': {
      display: 'flex',
      '& > *': {
        margin: '16px 16px 0 16px'
      }
    },
    'edit-profile': {
      fontSize: '12px',
      float: 'right',
      padding: '0 !important',
      '&MuiButtonBase-root': {
        padding: 0
      }
    },
    'profile-card-badge-co-founder': {
      borderStyle: 'double',
      borderWidth: '1px',
      borderColor: 'rgb(131, 131, 131)',
      userSelect: 'none',
      padding: '4px',
      margin: '0 8px'
    },
    'profile-card-badge-super-admin': {
      borderStyle: 'double',
      borderWidth: '1px',
      borderColor: 'rgb(131, 131, 131)',
      userSelect: 'none',
      padding: '4px',
      margin: '0 8px'
    },
    'profile-card-badge-system-admin': {
      borderStyle: 'dotted',
      borderWidth: '1px',
      borderColor: 'rgb(214, 214, 214)',
      userSelect: 'none',
      padding: '4px',
      margin: '0 8px'
    },
    'profile-card-badge-developer': {
      borderWidth: '1px',
      borderColor: 'rgb(236, 236, 236)',
      borderStyle: 'dotted',
      userSelect: 'none',
      padding: '4px',
      margin: '0 8px'
    },
    'profile-card-badge-designer': {
      background:
        ' radial-gradient(circle at 20% 128%,#2b31fa 15%,#ab771d 35%,#9e1b3c 55%,#178085 75%,#d60000 95%)',
      '-webkit-background-clip': 'text',
      backgroundClip: 'text',
      '-webkit-text-fill-color': 'transparent',
      borderStyle: 'groove',
      borderWidth: '1px',
      userSelect: 'none',
      padding: '4px',
      margin: '0 8px'
    },
    'profile-card-badge-photographer': {
      border: 'dotted',
      borderWidth: '1px',
      borderColor: 'rgb(10, 10, 10)',
      userSelect: 'none',
      padding: '4px',
      margin: '0 8px'
    },
    disabled: {
      opacity: '0.3',
      textDecoration: 'none',
      pointerEvents: 'none'
    }
  },
  { name: 'bund-' }
)

export const ProfileCard = (props) => {
  const {
    user,
    buid,
    userName,
    fullName,
    phoneNumber,
    emailAddress,
    firstName,
    lastName,
    lastSeen,
    online,
    profileImage,
    profileWebpImage,
    buRole,
    buPermission,
    className,
    badges,
    style,
    social,
    ...rest
  } = props

  const classes = useStyles()

  return (
    <ProfileCardBase>
      <div
        style={style}
        className={clsx(classes['profile-card'], className)}
        {...rest}>
        <UserIcon
          profileImage={profileImage}
          profileWebpImage={profileWebpImage}
          online={online}
          editProfile={classes['edit-profile']}
          rootIcon={classes['root-icon']}
          onlineBadge={classes['online-badge']}
          offlineBadge={classes['offline-badge']}
          userNameClass={classes['profile-card-user-name']}
          userName={userName}
          fullName={fullName}
        />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
          <p className={clsx(classes['profile-card-full-name'], 'text-color')}>
            {userName}@{buid}
          </p>
          <Role buRole={buRole} classes={classes['profile-card-role']} />
        </div>
        <Badges badges={badges} classes={classes} />
        {emailAddress && (
          <Anchor
            className={classes.email}
            href={'mailto:' + emailAddress}
            icon={<i className="fa fa-envelope"></i>}
            style={{
              fontSize: '14px'
            }}>
            {emailAddress}
          </Anchor>
        )}
        <Social
          social={social}
          socialClasses={classes.social}
          disabledClass={classes.disabled}
        />
      </div>
    </ProfileCardBase>
  )
}

ProfileCard.propTypes = {
  user: PropTypes.string,
  name: PropTypes.node,
  userName: PropTypes.node,
  buRole: PropTypes.node,
  buPermission: PropTypes.node,
  profileImage: PropTypes.node,
  online: PropTypes.bool,
  social: PropTypes.oneOfType([PropTypes.object, PropTypes.node]),
  badges: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.array,
    PropTypes.string,
    PropTypes.oneOf([
      'Co-Founder',
      'Super Admin',
      'System Admin',
      'Developer',
      'Designer',
      'Photographer'
    ])
  ])
}

ProfileCard.displayName = 'pc'

export default ProfileCard
